import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PrintBatchData, IBatches } from '@app/services/batches/print-batches';
import { PrintService } from '@app/dashboard/print/services/print.service';
import { MatDialog } from '@angular/material/dialog';
import { RecentlyPrintedDialog } from '@app/dashboard/print/components/recently-printed-dialog/recently-printed-dialog';
import { StatusFilters, ShippingStatus } from '@pdqdev/pdq-shared/dist/CarrierData';
import { FulfillService } from '@app/pages/workspace/fulfill/fulfill.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LayoutService } from '@app/storybook/services/layout/layout.service';

interface Snackbar {
  variant: 'success' | 'info' | 'failure';
  text: string;
  state: 'in' | 'out';
  mode: 'bottom' | 'top';
}

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'fulfill-page',
  templateUrl: './fulfill.component.html',
  styleUrls: ['./fulfill.component.scss'],
  standalone: false,
})
export class FulfillPageComponent implements OnInit, OnDestroy {
  @ViewChild('toggle') toggle: ElementRef;
  batches: IBatches = {
    printing: [],
    recentlyDone: [],
    running: [],
  };
  showHistory;
  snackbar: Snackbar;
  loading = false;
  isLoadedInitialData = false;
  isCustomFulfillmentViewEnabled: boolean = false;
  destroy$ = new Subject();

  usePaginatedFulfillment = this.fulfillService.usePaginatedFulfillment;
  constructor(
    private printService: PrintService,
    private dialog: MatDialog,
    private fulfillService: FulfillService,
    public layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.fulfillService.initService();

    this.fulfillService.onLoading.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.loading = state;
    });

    this.fulfillService.isLoadedBatchesData$.pipe(takeUntil(this.destroy$)).subscribe((isLoaded) => {
      if (isLoaded) {
        this.isLoadedInitialData = true;
      }
    });
    this.fulfillService.isCustomFulfillmentScanningViewEnabled$.subscribe((value: boolean) => {
      this.isCustomFulfillmentViewEnabled = value;
    });
  }

  checkTheAbilityToReturnBatchToAssign(batch: PrintBatchData) {
    const notPossibleSendBatch = batch.orders.some((order) => {
      if (
        StatusFilters.IN_TRANSIT.includes(order.deliveryTransaction?.translatedShippingStatus as ShippingStatus) ||
        StatusFilters.DELIVERED.includes(order.deliveryTransaction?.translatedShippingStatus as ShippingStatus)
      ) {
        return true;
      }
    });

    return !notPossibleSendBatch;
  }

  public OpenRecentlyPrintedDialog(): void {
    this.dialog.open(RecentlyPrintedDialog, {
      maxWidth: '90vw',
      maxHeight: '90vh',
      width: '750px',
      height: '75vh',
      autoFocus: false,
      data: [],
    });
  }

  ngOnDestroy(): void {
    this.printService.printPageDestroyed.next(null);
    this.fulfillService.destroyed$.next(true);
    this.fulfillService.clearCardIsleDevicesCache();
    this.fulfillService.resetService();
  }
}
